import httpManager from "@/app/shared/utils/httpManager";

/**
 * Checks if the current customer has an incomplete WhatsApp (Gupshup) integration attempt
 */
export async function checkIncompleteAttempt() {
  const url = `/channels/channel-customer/incomplete`;
  const response = await httpManager.get(url);
  return response?.data;
}
